import React, { useEffect, useState } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import PageLoading from './components/pageLoading';
import routes from './routes/routes';



function App() {
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    // Simulate initialization
    const timer = setTimeout(() => setInitialized(true), 1000);
    return () => clearTimeout(timer);
  }, []);

  if (!initialized) {
    return <PageLoading />;
  }
  const renderRoutes = (routes) =>
    routes.map((route, i) => {
      if (route.childRoutes) {
        return route.childRoutes.map((child, j) => (
          <Route
            key={`${i}-${j}`}
            exact={child.exact}
            path={`${route.path}${child.path}`}
            component={child.component}
          />
        ));
      }

      return (
        <Route
          key={i}
          path={route.path}
          exact={route.exact}
          component={route.component}
        />
      );
    });
  return <Switch>
    {/* ✅ Redirect from `/` to `/home` */}
    <Route exact path="/">
      <Redirect to="/home" />
    </Route>

    {/* ✅ Render all defined routes */}
    {renderRoutes(routes)}
  </Switch>;
}

export default App;
